import axios from "axios"
import { useState } from "react";
import "./uploadFile.css"
import { useSelector } from "react-redux";
import zipIcon from "./iconUpload/zipIcon.png" 
import pdf from "./iconUpload/pdf.png" 
import exel from "./iconUpload/exel.png" 
import world from "./iconUpload/world.png" 
const random = ()=>{
  return  Math.random(Math.floor() * 100000)
}
export default function UploadFileTaskMeneger({handleChangeFile}) {
    
    const [files,setFile] = useState(null)
    const [fileName, setFileName] = useState('');
    const [realfileData, setrealfileData] = useState('');
    const [params,setParams] = useState("")
    const [progress, setProgress] = useState(0);

    

    function generateUniqueId() {
      const timestamp = Date.now().toString(36); // Convert current timestamp to base36 string
      const randomChars = Math.random().toString(36).substr(2, 5); // Generate random characters
      
      return timestamp + randomChars;
    }
    
    let getCompanyID = useSelector(compID => compID.checkedSessionReducer)
    let getmyinfo = useSelector(compID => compID.getMayInfoReducer)

    const handleFileChange = (e) => {

      const file = e.target.files[0];
      setrealfileData(e.target.files[0])

  
      const newFileName =  random(); // New file name
      const renamedFile = new File([file], newFileName, {
        type: file.type,
        lastModified: file.lastModified,
      });
      setFileName(newFileName);
    
        setFile(renamedFile);
        
       
        const formData = new FormData();
        formData.append('files',renamedFile);
        const uniqueId = generateUniqueId();
       
        axios.post('/uploadTaskMeneger/api', formData,{
            params:{
              isChild:false,
              idFiles:uniqueId,
              fileName:e.target.files[0].name,
            },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              setProgress(percentCompleted);
            },
            
          
        })
        .then(response => {
          // Handle the response if needed
          console.log(response.data);
        })
        .catch(error => {
          // Handle errors if any
          console.error(error);
        });


        let filteOptions={
            companyIDS:getCompanyID.checkedSession,
            fileName:e.target.files[0].name,
            idFiles:uniqueId,
            type:e.target.files[0].type,
            isChild:false,
            index:0,
            name:random()

        }
       
        handleChangeFile(filteOptions)
        setParams(filteOptions)
      };

      const handleDeleteLocal=()=>{
        setFile(null)
        setFileName("")
        setrealfileData("")
        console.log(params);
        axios.post('/deletefileByKey/api', {
          allFileOption:params,
          idFiles:params.idFiles
        })
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
        
      }

        return (
            <div className="uploadFile">
            <label htmlFor="upload">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
  <path opacity="0.3" d="M14.0003 4.66663C8.85533 4.66663 4.66699 8.85496 4.66699 14C4.66699 19.145 8.85533 23.3333 14.0003 23.3333C19.1453 23.3333 23.3337 19.145 23.3337 14C23.3337 8.85496 19.1453 4.66663 14.0003 4.66663ZM19.8337 15.1666H15.167V19.8333H12.8337V15.1666H8.16699V12.8333H12.8337V8.16663H15.167V12.8333H19.8337V15.1666Z" fill="white"/>
  <path d="M15.1663 8.16671H12.833V12.8334H8.16634V15.1667H12.833V19.8334H15.1663V15.1667H19.833V12.8334H15.1663V8.16671ZM13.9997 2.33337C7.55967 2.33337 2.33301 7.56004 2.33301 14C2.33301 20.44 7.55967 25.6667 13.9997 25.6667C20.4397 25.6667 25.6663 20.44 25.6663 14C25.6663 7.56004 20.4397 2.33337 13.9997 2.33337ZM13.9997 23.3334C8.85467 23.3334 4.66634 19.145 4.66634 14C4.66634 8.85504 8.85467 4.66671 13.9997 4.66671C19.1447 4.66671 23.333 8.85504 23.333 14C23.333 19.145 19.1447 23.3334 13.9997 23.3334Z" fill="white"/>
            </svg>
            <p>Добавить файлы</p>
              <input type="file" id="upload" style={{ display: "none" }} onChange={handleFileChange}/>
            </label>
            {(() => {
          if (files) {
            if (files.type == "image/png" || files.type == "image/jpeg") {
              return (
                <div >
                    <div  className="imgUploadCont">
                      <img src={URL.createObjectURL(files)} alt="asd"/>
                      <span class="material-symbols-outlined" onClick={handleDeleteLocal}>delete_forever</span>
                     
                    </div>
                    <p>{realfileData.name}</p>
                </div>
              )
              
            
            }else if(files.type == "application/x-zip-compressed"){
                  return (
                      <div>
                            <div className="ZipUploadCont"  >
                              <h1 style={{cursor:"pointer"}} ><img src={zipIcon} alt="" /></h1>
                              <span class="material-symbols-outlined" onClick={handleDeleteLocal}>delete_forever</span>
                             
                        </div>
                        <p>{realfileData.name}</p>
                      </div>
                  )
            }
            else if(files.type == "application/pdf"){
              return (
                <div>
                     <div className="pdfUploadCont">
                        <h1 style={{cursor:"pointer"}} ><img src={pdf} alt="" /></h1>
                        <span class="material-symbols-outlined" onClick={handleDeleteLocal}>delete_forever</span>
                   </div>
                   <p>{realfileData.name}</p>
                </div>
              )
        }
        else if(files.type == "video/mp4"){
          return (
            <div>
                 <div className="pdfUploadCont" >
                <video width="320" height="240" controls autoPlay>
                        <source src={URL.createObjectURL(files)} type={URL.createObjectURL(files)} />
                        <source src={URL.createObjectURL(files)} type={URL.createObjectURL(files)}/>
                      Your browser does not support the video tag.
                      </video>
                      <span class="material-symbols-outlined" onClick={handleDeleteLocal}>delete_forever</span>
            </div>
            <p>{realfileData.name}</p>
            </div>
          )
          }
          else if(files.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
            return (
              <div>
                  <div className="pdfUploadCont">
                  <h1 style={{cursor:"pointer"}} ><img src={exel} alt="" /></h1>
                  <span class="material-symbols-outlined" onClick={handleDeleteLocal}>delete_forever</span>
              </div>
              <p>{realfileData.name}</p>
              </div>
            )
          }
          else if(files.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document"){
          
            return (
            <div>
                  <div className="pdfUploadCont">
                  <h1 style={{cursor:"pointer"}} ><img src={world} alt="" /></h1>
                  <span class="material-symbols-outlined" onClick={handleDeleteLocal}>delete_forever</span>
              </div>
              <p>{realfileData.name}</p>
            </div>
            )
          }
          } 
             })()}
          </div>
        )
}